import {Component, OnInit, Input, OnChanges, AfterViewChecked} from '@angular/core';
import { TitleLineConfigurations } from '../title/title.configurations';
import { IndicatorBasicConfigurations } from './indicator-basic.configurations';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { KlaHttpService } from '../services/kla.http.service';
import { CropConfiguration } from './crop-configuration';
import { Image } from '../services/kla.data.models';
import { CommonModule } from '@angular/common';
import { ImageObjectComponent } from '../image-object/image-object.component';
import { SocialMediaButtonsComponent } from '../social-media-buttons/social-media-buttons.component';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-indicator-basic',
  templateUrl: './indicator-basic.component.html',
  styleUrls: ['./indicator-basic.component.scss'],
  standalone: true,
  imports: [ CommonModule, ImageObjectComponent, SocialMediaButtonsComponent, DynamicContentComponent, StripSpecialCharsPipe ]
})
export class IndicatorBasicComponent implements OnInit {

  @Input()
  public image: string;

  @Input()
  public imagePosition = 'left';

  @Input()
  public config: IndicatorBasicConfigurations;

  @Input()
  public indicatorTitle: string;

  @Input()
  public cropConfig: CropConfiguration;

  @Input()
  public imageObject: Image;

  @Input()
  public color = '#3C3D3D';

  @Input()
  public lineConfig: TitleLineConfigurations;

  get imageHeight() {
    return this.config.imageHeight + 'px';
  }
  get imageWidth() {
    if(this.imagePosition == 'full-width' && !this.config.imageWidth) {
      return '100%';
    }
    if(!this.config.imageWidth) {
      return '380px';
    }
    if(window.innerWidth < this.config.imageWidth || window.innerWidth < 992) {
      return '100%';
    }
    return `${this.config.imageWidth}px`;
  }

  get displayWidth() {
    return window.innerWidth;
  }

  public imagePath;

  public lineSizes: Array<string> = [
    'line-big',
    'line-small',
    'line-small'
  ];

  public lineColor = '#67b158';

  public description: SafeHtml;

  constructor(
    private sanitizer: DomSanitizer,
    private httpService: KlaHttpService
  ) {}

  ngOnInit() {
    if (!this.config) {
      this.config = <IndicatorBasicConfigurations>{};
    }
    this.description = this.sanitizer.bypassSecurityTrustHtml(
      this.config.description
    );

    if (this.lineConfig) {
      this.lineColor = this.lineConfig.sectionColor;
      this.lineSizes = [];
      for (let index = 0; index < this.lineConfig.numberOfSections; index++) {
        this.lineSizes.push(index == this.lineConfig.sectionIndex ? 'line-big' : 'line-small');
      }
    }

    if (this.config.color) {
      this.color = this.config.color;
    }

    if (typeof this.imageObject != 'string') {
      this.imageObject.width = this.imagePosition == 'full-width' ? 1400 : 900;
    }

    const imageConfig: Image = {
      id: this.imageObject?.id,
      width: +this.imageObject?.width,
      height: +this.imageObject?.height,
      cropConfig: this.imageObject?.crop_config,
    };

    if (imageConfig.cropConfig && (imageConfig.width || imageConfig.height)) {
      this.imagePath = this.httpService.getCroppedImagePath(imageConfig);
    } else {
      this.imagePath = this.httpService.getImagePath(imageConfig.id, imageConfig.width);
    }
  }

}
